// This icon file is generated automatically.
var PDashOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M.75 6.44h2.5v1.12H.75V6.44zm5 0h2.5v1.12h-2.5V6.44zm5 0h2.5v1.12h-2.5V6.44z", "fill-rule": "nonzero" } }] }, "name": "p-dash", "theme": "outlined" };
export default PDashOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDashOutlined.js
// module id = 3323
// module chunks = 0